<template>
    <v-card>
        <v-card-title>
            <span class="text-h5">{{ title }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="skip"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-container class="p-4">
            <v-row class="text-caption">
                <template v-for="(item, index) in resources.skier_types" >
                    <v-col cols="12" md="4">
                        <h5>TYPE {{ toRoman(index+1)}}</h5>
                        <h6>{{ item.title }}</h6>
                        <span v-html="(item.content || '').replaceAll('\\r','').replaceAll('\\n','')"></span>
                    </v-col>
                </template>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    :md="reservee_gender?4:6"
                >
                    <with-validation field="full_name" v-slot="{bind,on}">
                        <v-text-field
                            autocomplete="off"
                            v-on="on"
                            v-bind="bind"
                        ></v-text-field>
                    </with-validation>

                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    :md="reservee_gender?4:6"
                >
                    <with-validation field="dob" v-slot="{bind,on}">
                        <v-text-field
                            autocomplete="off"
                            :label="bind.label"
                            :error="bind.error"
                            :error-messages="bind.errorMessages"
                            v-model="tmpDob"
                            @blur="saveDob();validate(['dob'])"
                            v-mask="'##/##/####'"
                            placeholder="mm/dd/yyyy"
                            prepend-icon="mdi-calendar"
                        ></v-text-field>
                    </with-validation>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    v-if="reservee_gender"
                >
                    <with-validation class="mt-0" field="gender" v-slot="{bind,on}" >
                        <v-radio-group row v-bind="bind" v-on="on">
                            <v-radio 
                                v-for="(option, index) in gender_options"
                                :key="index"
                                :value="index"
                                :label="option"
                            ></v-radio>
                        </v-radio-group>
                    </with-validation>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <with-validation field="height" v-slot="{bind,on}">
                        <v-select
                            v-bind="bind"
                            v-on="on"
                            @click="scrollHeight"
                            :items="resources.heights"
                            :menu-props="{auto:true,offsetY:true,contentClass: 'big-menu renter-height'}"
                            item-text="name"
                            item-value="value"
                            dense
                            v-on:change="heightChanged"
                        >
                            <template v-slot:selection="{ item }">
                                {{ getHeightText(item) }}
                            </template>
                            <template v-slot:item="{ item }">
                                {{ getHeightText(item) }}
                            </template>
                        </v-select>
                    </with-validation>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <with-validation field="weight" v-slot="{bind,on}">
                        <v-text-field
                            v-bind="bind"
                            v-on="on"
                            v-mask="'###'"
                            dense
                            maxLength="3"
                            v-on:change="weightChanged"
                        ></v-text-field>
                    </with-validation>

                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <with-validation field="shoe_size" v-slot="{bind,on}">
                        <v-select
                            v-bind="bind"
                            v-on="on"
                            @click="scrollShoeSize"
                            :items="shoe_sizes"
                            :menu-props="{auto:true,offsetY:true,contentClass: 'big-menu shoe-size'}"
                            item-text="name"
                            item-value="model"
                            dense
                            v-on:change="shoeSizeChanged"
                        >
                            <template v-slot:selection="{ item }">
                                {{ getShoeSize(item) }}
                            </template>
                            <template v-slot:item="{ item }">
                                {{ getShoeSize(item) }}
                            </template>
                        </v-select>
                    </with-validation>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <with-validation field="skier_type" v-slot="{bind,on}">

                        <v-select
                            v-bind="bind"
                            v-on="on"
                            menu-props="left"
                            :items="resources.skier_types"
                            item-text="title"
                            item-value="id"
                        >
                            <template v-slot:append-outer>

                                <v-btn
                                    icon
                                    @click="ui__openModalByName({name:'dialog_skier_types'})"
                                >
                                    <v-icon>mdi-information-outline</v-icon>
                                </v-btn>

                            </template>
                        </v-select>
                    </with-validation>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <with-validation field="package_id" v-slot="{bind,on}">
                        <v-select
                            v-bind="bind"
                            v-on="on"
                            :items="packages"
                            item-text="title"
                            item-value="id"
                            v-on:change="changePackage()"
                            @click:append-outer="$emit('show-rates')"
                        >
                            <template v-slot:append-outer>

                                <v-btn
                                    icon
                                    @click="ui__openModalByName({name:'dialog_rental_rates'})"
                                v-if="!hide_rate">
                                    <v-icon >mdi-information-outline</v-icon>
                                </v-btn>

                            </template>

                        </v-select>
                    </with-validation>
                </v-col>
                <v-col cols="12">
                    <template v-if="show_addons == 1">
                        <v-divider class="mx-0"></v-divider>
                        <v-row>
                            <v-col md="12">
                                <h5>Add-ons</h5>
                                <v-checkbox
                                    class="mt-0"
                                    :hide-details="true"
                                    multiple
                                    :key="'checkbox__package_addon_'+addon.id"
                                    v-for="addon in _originalPackageAddons"
                                    v-model="addonsList_x"
                                    :label="addon.title + (!$store.state.model.reservation.group_link_id && (do_not_show_price_on_checkout!=1 && !($store.state.model.reservation._type=='advance' && !$store.state.model.reservation.is_seasonal && no_priceing_checkouts==1)) ?(' ('+((is_in_special_period && !$store.state.model.reservation.is_seasonal)?'$' + ((parseFloat(addon.price.replace('$', ''))+((parseFloat(addon.price.replace('$', ''))*special_period_increase)/100))).toFixed(2):addon.price)+')'):'') "
                                    :value="addon.id"
                                    v-on:change="addonsChanged"
                                >

                                </v-checkbox>
                            </v-col>
                            <!--                        <v-col md="6" v-if="isSnowBoardPackage">-->
                            <!--                            <h5>Snowboard Stance</h5>-->
                            <!--                            <v-radio-group row v-model="model.snowboard_type" class="mt-0">-->
                            <!--                                <v-radio v-for="type in resources.snowboard_types"-->
                            <!--                                         :value="type.value"-->
                            <!--                                         :label="type.name"-->
                            <!--                                         :key="'radio__snowboard_type_'+type.value">-->

                            <!--                                </v-radio>-->
                            <!--                            </v-radio-group>-->
                            <!--                        </v-col>-->
                        </v-row>
                    </template>
                </v-col>
                <v-col cols="12" md="6">
                    <errors-alert :errors="v__getErrors()"></errors-alert>
                </v-col>

            </v-row>
            <v-spacer></v-spacer>
            <!-- <v-btn class="mb-5" @click="skip">Skip</v-btn> -->
            <v-btn class="mb-5" color="primary" @click="saveForm">Save</v-btn>
        </v-container>
    </v-card>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import moment                   from 'moment';
import WithValidation             from "../../components/inputs/WithValidation";
import ErrorsAlert           from "../../components/partials/ErrorsAlert";
import DateUtilsMixin        from "../../mixins/DateUtilsMixin";
import UiManagerMixin        from "../../mixins/UiManagerMixin";
import ValidatableComponent  from "../../mixins/ValidatableComponent";
import reservee_form__fields from "../../validation/fields/reservee_form__fields";
import reservee_kgs_form__fields from "../../validation/fields/reservee_kgs_form__fields";
import reservee_lbs_form__fields from "../../validation/fields/reservee_lbs_form__fields";
import reservee_form__rules  from "../../validation/scenarios/reservee_form__rules";
import prepay_reservee_form__fields from "../../validation/fields/prepay_reservee_form__fields";
import prepay_kgs_reservee_form__fields from "../../validation/fields/prepay_kgs_reservee_form__fields";
import prepay_lbs_reservee_form__fields from "../../validation/fields/prepay_lbs_reservee_form__fields";


export default {
    name      : "DialogReserveeForm",
    components: {ErrorsAlert, WithValidation},
    props     : ['modalId'],
    mixins    : [ValidatableComponent, UiManagerMixin, DateUtilsMixin],
    data      : () => ({

        tmpDob: '',
        addonsList: [],
        _originalPackageAddons: null,
        hideAge: false,
        hideHeight: false,
        hideWeight: false,
        hideShoeSize: false,
        changeForAddonsIsTriggered: false,
        prepay_discount_price: 0,
        prepay_sales_tax: 0,
        prepay_package_price: 0,
        prepayTax: null
    }),
    computed  : {

        ...mapGetters(['packages_list_data', 'is_in_special_period', 'special_period_increase', 'book_me_host_code', 'do_not_show_price_on_checkout']),
        title() {
            const index = this.$store.state.model.reservees.findIndex(r => r._id === this.model?._id);
            return index >= 0 ? "Edit renter #" + (index + 1) : "Add renter";
        },
        shoe_sizes() {
            if(this.$store.state.resources.config.frontend_view_folder == "frontend.2ndave"){
                return this.$store.state.resources.shoe_sizes_2ndave;
            }else{
                return this.$store.state.resources.shoe_sizes;
            }
        },
        modalState: {
            get() {
                return this.$store.state.ui.modalsState[this.modalId];
            },
            set(newModel) {
                this.$store.commit('set_model_value', {
                    path : 'ui.modalState.' + this.modalId,
                    value: newModel
                })
            }
        },
        model() {
            const model = this.modalState ? this.modalState.model : null;

            if (model.addons.length) {
                this.addonsList_x = model.addons;
            }

            return model;
        },
        resources() {
            return this.$store.state.resources;
        },
        discount() {
            return parseInt(this.$store.state.resources.config.discount);
        },
        discount_type() {
            return this.$store.state.resources.config.discount_type;
        },
        hide_rate() {
            if(this.$store.state.model.reservation._type == 'kiosk'){
                return parseInt(this.$store.state.resources.config.hide_rate_kiosk);
            }
            return parseInt(this.$store.state.resources.config.hide_rate);
        },
        config(){
            return this.$store.state.resources.config;
        },
        is_buddy_service_enabled() {
            return this.$store.state.resources.config.is_buddy_service_enabled;
        },
        buddy_addon_id(){
            return this.$store.state.resources.config.buddy_addon_id;
        },
        hideLimitation() {
            return this.hideAge || this.hideHeight || this.hideWeight || this.hideShoeSize;
        },
        is_holiday_or_weekend() {
            let day = this.$store.state.model.reservation.date_pickup;
            let is_holiday_or_week_day = false;
            if(this.$store.state.resources.config.holidays!==null){
                for (const [key, value] of Object.entries(this.$store.state.resources.config.holidays)) {
                    if(value.start!==null && value.end!==null) {
                        is_holiday_or_week_day = moment(day, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                        if (is_holiday_or_week_day) break;
                    }
                }
            }
            let is_weekend = moment(day).isoWeekday()==5 || moment(day).isoWeekday()==6;
            return is_weekend || is_holiday_or_week_day;
        },
        is_prepay() {
            return this.$store.state.model.reservation.is_prepay;
        },
        multi_day_is_enabled() {
            return parseInt(this.$store.state.resources.config.multi_day_is_enabled);
        },
        multi_day_start_after() {
            return parseInt(this.$store.state.resources.config.multi_day_start_after);
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        packages() {
            let selectItems = [];
            if(this.$store.state.model.reservation.group_link_id == 0){
                const days = moment(this.$store.state.model.reservation.date_return).diff(moment(this.$store.state.model.reservation.date_pickup), 'days') + 1;
                this.packages_list_data.forEach(g => {
                    let this_category_packages = g.items.filter((item) => {
                        let current_rate = "0";
                        if(item.hasOwnProperty('current_rate')){
                            current_rate = item.current_rate.replace('$', '');
                        }
                        return parseInt(current_rate)!==0;
                    })
                    if(this_category_packages.length !== 0){
                        selectItems.push({header: g.title});
                        if(this.$store.state.resources.config.frontend_view_folder == 'frontend.skigd'){
                            selectItems.push(...g.items.map(i => ({...i, title: i.title + ' - ' + ((this.$store.state.model.reservation._type == 'kiosk' && this.$store.state.model.reservation.single_day_type=='afternoon')?i.half_day_rate: (this.$store.state.model.reservation.single_day_type=='night'?i.night_rate:i.current_rate )) + ((this.discount!==0 && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                        }
                        else if(this.is_prepay){
                            selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((this.config.is_prepay_discount=="1" && this.config.prepay_discount!="0") ? i.current_rate + ' (-'+this.config.prepay_discount+'%)': i.current_rate )})));
                        }
                        else if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_12'){
                            if(this.$store.state.model.reservation._type == 'advance'){
                                selectItems.push(...this_category_packages.map(i => ({...i, title: i.title})));
                                // if(this.$store.state.model.reservation.single_day_type=='multiday'){
                                //     selectItems.push(...g.items.map(i => ({...i, title: i.title + ' - ' + i.current_rate  + ((this.discount!==0 && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                                //     // selectItems.push(...g.items.map(i => ({...i, title: i.title + ' - ' + ((days == 2 )?i.day_2_Rate: (days == 3) ?i.day_3_Rate:(days == 4)?i.day_4_Rate:(days == 5)?i.day_5_Rate:(days > 5)?i.additional_day_rate:i.current_rate ) + ((this.discount!==0 && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                                // }else{
                                //     selectItems.push(...g.items.map(i => ({...i, title: i.title + ' - ' + ((this.$store.state.model.reservation.single_day_type=='afternoon')?i.halfDayRate: this.$store.state.model.reservation.single_day_type=='morning'?i.morningRate:this.$store.state.model.reservation.single_day_type=='twilight'?i.twilightRate:this.$store.state.model.reservation.single_day_type=='beech_pass'?i.beechPassRate:(this.$store.state.model.reservation.single_day_type=='night'?i.nightRate:i.current_rate )) + ((this.discount!==0 && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                                // }
                            }else{
                                selectItems.push(...g.items.map(i => ({...i, title: i.title + ' - ' +"$"+ parseFloat(i.current_rate.replace('$', '')).toFixed(2) })));
                            }
                        }
                        else if(this.$store.state.resources.config.delivery == 1 && window.location.href.includes('delivery')){

                        selectItems.push(...g.items.map(i => ({...i, title: i.title + ' - ' +"$"+ parseFloat(i.current_rate.replace('$', '')).toFixed(2) })));
                    }
                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_7'){
                        selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((this.multi_day_is_enabled && days>this.multi_day_start_after && this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.multi_day_rate.replace('$', ''))+((parseFloat(i.multi_day_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):(days>this.multi_day_start_after && days<7 && !this.$store.state.model.reservation.is_seasonal)?i.multi_day_rate:(days>this.multi_day_start_after && days>=7 && !this.$store.state.model.reservation.is_seasonal)?i.day_7_plus: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }
                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_5'){
                        if(window.location.hostname == 'rentals.alpenhausonline.com'){
                            selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((days>5 && !this.$store.state.model.reservation.is_seasonal)?i.day_6_rate:(days==5 && !this.$store.state.model.reservation.is_seasonal)?i.day_5_rate:(days==4 && !this.$store.state.model.reservation.is_seasonal)?i.day_4_rate: (days==3 && !this.$store.state.model.reservation.is_seasonal)?i.day_3_rate: (days==2 && !this.$store.state.model.reservation.is_seasonal)?i.day_2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                        }else{
                            selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' +
                                ((this.$store.state.resources.config.frontend_view_folder == "frontend.winterpark" && days > 8 && !this.$store.state.model.reservation.is_seasonal)
                                    ? i.day_9_rate :
                                (this.$store.state.resources.config.frontend_view_folder == "frontend.winterpark" && days > 7 && !this.$store.state.model.reservation.is_seasonal)
                                    ? i.day_8_rate :
                                (days == 7 && !this.$store.state.model.reservation.is_seasonal)
                                    ? i.day_7_rate :
                                (days == 6 && !this.$store.state.model.reservation.is_seasonal)
                                    ? i.day_6_rate :
                                (days == 5 && !this.$store.state.model.reservation.is_seasonal)
                                    ? i.day_5_rate :
                                (days == 4 && !this.$store.state.model.reservation.is_seasonal)
                                    ? i.day_4_rate :
                                (days == 3 && !this.$store.state.model.reservation.is_seasonal)
                                    ? i.day_3_rate :
                                (days == 2 && !this.$store.state.model.reservation.is_seasonal)
                                    ? i.day_2_rate :
                                (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)
                                    ? "$" + ((parseFloat(i.current_rate.replace('$', '')) +
                                              ((parseFloat(i.current_rate.replace('$', '')) * this.special_period_increase) / 100)).toFixed(2))
                                    : i.current_rate) +
                                (((this.discount_type == "percentage" && this.discount !== 0) &&
                                  !parseInt(this.$store.state.model.reservation.is_from_kiosk)) ? ' (-' + this.discount + '%)' : '')
                        })));
                        }
                    }
                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_5_1'){
                        selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((days>2 && !this.$store.state.model.reservation.is_seasonal)?i.day_3_rate:(days==2 && !this.$store.state.model.reservation.is_seasonal)?i.day_2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }
                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_5_2'){
                        if(this.$store.state.model.reservation.single_day_type=='afternoon'){
                            selectItems.push(...g.items.map(i => ({...i, title: i.title + ' - ' + i.half_day_rate })));
                        }else{
                            selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((days>6 && !this.$store.state.model.reservation.is_seasonal)?i.day_7_rate:(days==6 && !this.$store.state.model.reservation.is_seasonal)?i.day_6_rate:(days==5 && !this.$store.state.model.reservation.is_seasonal)?i.day_5_rate:(days==4 && !this.$store.state.model.reservation.is_seasonal)?i.day_4_rate: (days==3 && !this.$store.state.model.reservation.is_seasonal)?i.day_3_rate: (days==2 && !this.$store.state.model.reservation.is_seasonal)?i.day_2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                        }
                    }
                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_5_3'){
                        if(this.$store.state.model.reservation.single_day_type=='afternoon'){
                            selectItems.push(...g.items.map(i => ({...i, title: i.title + ' - ' + i.half_day_rate })));
                        }else{
                            selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                        }
                    }
                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_9'){
                        selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + (this.$store.state.model.reservation.is_seasonal?i.current_rate:(days>1 && days <4)?i.day2_rate:(days>=4)?i.day_4_plus:this.$store.state.model.reservation.single_day_type=='afternoon'?i.half_day_rate:this.$store.state.model.reservation.single_day_type=='night'?i.night_rate:(this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }

                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_10'){
                        selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + (this.$store.state.model.reservation.is_seasonal?i.current_rate:(days==2)?i.day2_rate:(this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }

                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_11'){
                        selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + (this.$store.state.model.reservation.is_seasonal?i.current_rate:(this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }

                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_13'){
                        selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((days>5 && !this.$store.state.model.reservation.is_seasonal)?i.day_6_plus:(days>1  && !this.$store.state.model.reservation.is_seasonal)?i.day2_5: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }

                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_14'){
                        selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((days>3 && !this.$store.state.model.reservation.is_seasonal)?i.day_4_plus:(days>1  && !this.$store.state.model.reservation.is_seasonal)?i.day2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }

                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_16'){
                        selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((days>4 && !this.$store.state.model.reservation.is_seasonal)?i.day_5_rate:(days>2  && !this.$store.state.model.reservation.is_seasonal)?i.day3_4_rate:(days==2  && !this.$store.state.model.reservation.is_seasonal)?i.day2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }
                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_17'){
                        selectItems.push(...g.items.map(i => ({...i, title: i.title + ' - ' + ((this.$store.state.model.reservation._type == 'kiosk' && this.$store.state.model.reservation.single_day_type=='afternoon')?i.half_day_rate: (this.$store.state.model.reservation.single_day_type=='night'?i.night_rate:(this.multi_day_is_enabled && days>this.multi_day_start_after && !this.$store.state.model.reservation.is_seasonal)?i.multi_day_rate:i.current_rate )) + ((this.discount!==0 && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }
                    else if(this.config.module_type_enabled != 0 && this.config.module_type == 'module_18'){
                        selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + (this.$store.state.model.reservation.single_day_type=='night'?i.night_rate:(this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                    }
                    else{
                        if(this.do_not_show_price_on_checkout!=1 && (!(this.$store.state.model.reservation._type=='advance' && !this.$store.state.model.reservation.is_seasonal && this.no_priceing_checkouts==1))){
                            selectItems.push(...this_category_packages.map(i => ({...i, title: i.title + ' - ' + ((this.multi_day_is_enabled && days>this.multi_day_start_after && this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.multi_day_rate.replace('$', ''))+((parseFloat(i.multi_day_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):(this.multi_day_is_enabled && days>this.multi_day_start_after)?i.multi_day_rate: this.$store.state.model.reservation.single_day_type=='day_hours' && this.is_holiday_or_weekend?i.weekends_and_holiday:this.$store.state.model.reservation.single_day_type=='day_hours' && !this.is_holiday_or_weekend?i.week_days_non_holiday:this.$store.state.model.reservation.single_day_type=='night_hours'?i.night_hours: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(i.current_rate.replace('$', ''))+((parseFloat(i.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):i.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'')})));
                        } else{
                            selectItems.push(...this_category_packages.map(i => ({...i, title: i.title})));
                        }
                    }
                }
            });

                selectItems = selectItems.filter( (item) => {
                    return (!item.hasOwnProperty('id') || ((this.$store.state.model.reservation._type=='kiosk' && item.remove_from_kiosk == 0) || (this.$store.state.model.reservation._type=='advance' && item.is_disabled == 0)) && (! this.hideLimitation || (this.hideLimitation && ! item.has_limitations)));
                })
            }else{
                this.packages_list_data.forEach(g => {
                    let this_category_packages = g.packages;
                    selectItems.push(...this_category_packages.map(i => ({...i, title: i.title})));
                });
            }

            return selectItems;
        },
        package_addons(){
            return this._originalPackageAddons.filter((element) => {
                return ((this.$store.state.model.reservation._type=='kiosk' && element.remove_from_kiosk != 1) || (this.$store.state.model.reservation._type=='advance'));
            });
        },
        isSnowBoardPackage() {
            return this.model.package_id ? this.packages.find(p => p.id === this.model.package_id)?.is_snowboard_package : false;
        },
        reservee_gender() {
            return parseInt(this.$store.state.resources.config.reservee_gender);
        },
        gender_options() {
            return this.$store.state.resources.config.gender_options;
        },
        dobFormatted() {
            return this.model.dob !== 'INVALID_FORMAT' ? this.dt_for_user(this.model.dob) : this.tmpDob;
        },
        no_priceing_checkouts() {
            return this.$store.state.resources.config.no_priceing_checkouts;
        },
        is_international_canadian(){
            return parseInt(this.$store.state.resources.config.is_international_canadian);
        },
        weight_unit_is_kg(){
            return parseInt(this.$store.state.resources.config.weight_unit_is_kg);
        },
        height_with_cm(){
            return parseInt(this.$store.state.resources.config.height_with_cm);
        },
        weight_with_kg(){
            return parseInt(this.$store.state.resources.config.weight_with_kg);
        },
        show_addons() {
            if(this.$store.state.model.reservation.group_link_id != 0 || this.is_prepay){
                return 0;
            }
            return 1;
        },
        addonsList_x: {
            get: function () {
                let checkedElements_ids = [];
                if(this.addonsList.length===0 && this.$store.state.model.reservation.group_link_id == 0 && !this.$store.state.model.reservation.is_prepay && this.$store.state.ui.modalsState[this.modalId].applyDefaultAddon == true){
                    this.$store.state.resources.package_addons.filter(element => {  if (element.by_default === 1) checkedElements_ids.push(element.id); })
                    this.addonsList = checkedElements_ids;
                    this.$store.state.ui.modalsState[this.modalId].applyDefaultAddon = false;
                }else{
                    checkedElements_ids = Object.assign([], this.addonsList);
                }
                return checkedElements_ids
            },
            set: function (newValue) {
                this.addonsList = Object.assign([], newValue);
            }
        }
    },
    watch: {
        addonsList_x: function (val, oldVal) {
            if(this.is_buddy_service_enabled && ! oldVal.includes(parseInt(this.buddy_addon_id)) && this.changeForAddonsIsTriggered){
                if (val.includes(parseInt(this.buddy_addon_id))) {
                    this.ui__openModalByName({name:'dialog_buddy_insurance'})
                }
            }
        }
    },
    methods   : {
        ...mapMutations(['reservee_save']),
        ...mapActions(['do_save_reservee', 'do_calculate_kiosk_cost']),

        addonsChanged(input) {
            this.changeForAddonsIsTriggered = true;
        },

        async saveForm() {
            if(!this.reservee_gender){
                this.model.gender = 'no specified'
            }
            if(this.is_prepay){
                if(String(this.prepay_sales_tax).includes("$")){
                    this.prepay_sales_tax = parseFloat(this.prepay_sales_tax.replace("$", "")).toFixed(2);
                }
                if(String(this.prepay_package_price).includes("$")){
                    this.prepay_package_price = parseFloat(this.prepay_package_price.replace("$", "")).toFixed(2);
                }
                this.model.package_price = this.prepay_package_price - (+this.prepay_sales_tax);
                this.model.prepay_tax = this.prepay_sales_tax;
                if(this.prepay_discount_price !== 0){
                    this.model.discount = parseFloat(this.prepay_discount_price.replace('$', '')).toFixed(2);
                }else{
                    this.model.discount = this.prepay_discount_price;
                }
            }

            if (await this.validate()) {
                this.model.addons = this.addonsList;

                let selected_package = this.packages.find(p => p.id === this.model.package_id);
                if(selected_package.is_snowboard_package){
                    let snowboardTypes = [];
                    _.find(this.$store.state.ui.modalsState, (m) => { (m.hasOwnProperty('reservee_modal_id') && m.reservee_modal_id == this.model._id) ? snowboardTypes.push(m) : true});
                    this.model.snowboard_type = snowboardTypes[snowboardTypes.length-1].snowboard_type;
                    snowboardTypes = Object.assign([], []);
                }

                this.reservee_save(this.model);
                await this.do_save_reservee();
                if(window.location.href.includes('prepay')){
                    this.calcualte_prepay_total();
                }
                // await this.do_calculate_kiosk_cost();
                this.modalState.next();
                this.$emit('modal-close');
            }
        },
        calcualte_prepay_total() {
            if(this.$store.state.model.reservation._type=='kiosk'){
                console.log('if is working');
                let sales_tax = 0;
                if(this.config.sales_tax_switch=="1"){
                    let tax = this.config.sales_tax;
                    if(this.is_international_canadian){
                        tax = parseFloat(this.config.sales_tax_pst) + parseFloat(this.config.sales_tax_gst);
                    }
                    sales_tax = ((+this.$store.state.model.reservation.prepay_total_packages_price)*(+tax))/100;
                }

                let total = (this.$store.state.model.reservation.prepay_total_packages_price + parseFloat(sales_tax)).toFixed(2);
                this.$store.commit('set_prepay_total_packages_price', total);

            }else{
                console.log('else is working');
                let prepay_total_packages_price = this.$store.state.model.reservation.prepay_total_packages_price;
                let sales_tax = 0;
                if(this.config.sales_tax_switch=="1"){
                    let tax = this.config.sales_tax;
                    if(this.is_international_canadian){
                        tax = parseFloat(this.config.sales_tax_pst) + parseFloat(this.config.sales_tax_gst);
                    }
                    sales_tax = ((+this.$store.state.model.reservation.prepay_total_packages_price)*(+tax))/100;
                }
                let fee = 0;
                if(parseInt(this.config.special_fee_at_checkout) == 1){
                    if(this.config.special_fee_type == "percentage"){
                        fee = (this.config.special_fixed_fee * prepay_total_packages_price)/100;
                    }else{
                        fee =  this.$store.state.model.reservees.length * this.config.special_fixed_fee;
                    }
                }
                prepay_total_packages_price = prepay_total_packages_price + parseFloat(sales_tax);

                prepay_total_packages_price = prepay_total_packages_price + parseFloat(fee);
                this.$store.commit('set_prepay_total_packages_price', prepay_total_packages_price.toFixed(2));
            }

        },
        toRoman(num, result = ''){
            const map = {
                M: 1000,
                CM: 900,
                D: 500,
                CD: 400,
                C: 100,
                XC: 90,
                L: 50,
                XL: 40,
                X: 10,
                IX: 9,
                V: 5,
                IV: 4,
                I: 1,
            };
            for (const key in map) {
                if (num >= map[key]) {
                    if (num !== 0) {
                        return this.toRoman(num - map[key], result + key);
                    }
                }
            }
            return result;
        },
        scrollShoeSize() {
            let age = -1;
            if(this.tmpDob !== null){
                age = moment().diff( this.tmpDob, 'years');
            }
            const scrollTopNumber = ((age > 12) || (age === -1)) ? 380 : 80;
            setTimeout(function () {
                document.querySelector('.shoe-size').scrollTop = scrollTopNumber;
            }, 100);
        },
        scrollHeight() {
            setTimeout(function () {
                document.querySelector('.renter-height').scrollTop = 555;
            }, 100);
        },
        saveDob() {
            let age = moment().diff( this.tmpDob, 'years');
            this.hideAge = age > this.$store.state.resources.config.age;
            this.model.dob = this.tmpDob ? (this.dt_from_user(this.tmpDob) ? ((age > 99) ? 'INVALID_AGE' : this.dt_from_user(this.tmpDob)) : this.dt_from_user(this.tmpDob) || 'INVALID_FORMAT') : this.tmpDob;
        },
        skip(){
            this.$store.commit('reservee_delete', this.model._id);
            if(window.location.href.includes('prepay')){
                    this.calcualte_prepay_total();
                }
            this.modalState.next();
            this.$emit('modal-close');
        },
        changePackage(){
            let selected_package = this.packages.find(p => p.id === this.model.package_id);

            if(this.model.package_id!=null){
                let selected_package_id = this.model.package_id.toString();
                this._originalPackageAddons = this.$store.state.resources.package_addons.filter((element) => {
                    return (element.removed_packages==null || (element.removed_packages!=null && !element.removed_packages.includes(selected_package_id)));
                });
            }

            if(this.$store.state.model.reservation.is_prepay=="1" && selected_package){
                let package_current_price = parseFloat(selected_package.current_rate.replace('$', '')).toFixed(2);
                if(this.config.is_prepay_discount=="1"){
                    let current_price_discount = (((parseFloat(package_current_price))*(parseFloat(this.config.prepay_discount)))/100).toFixed(2);
                    this.prepay_discount_price = "$"+ current_price_discount;
                    this.prepay_package_price = parseFloat(package_current_price) - parseFloat(current_price_discount);
                }else{
                    this.prepay_package_price = parseFloat(selected_package.current_rate.replace('$', ''));
                }
                if(this.config.sales_tax_switch=="1"){
                    let tax = this.config.sales_tax;
                    if(this.is_international_canadian){
                        tax = parseFloat(this.config.sales_tax_pst) + parseFloat(this.config.sales_tax_gst);
                    }
                    this.prepay_sales_tax = (((parseFloat(this.prepay_package_price))*(parseFloat(tax)))/100).toFixed(2);
                    this.prepay_package_price = "$"+ ((parseFloat(this.prepay_package_price) + parseFloat(this.prepay_sales_tax))).toFixed(2);
                    this.prepay_sales_tax = "$"+ this.prepay_sales_tax;
                }
                else{
                    this.prepay_package_price = "$"+ parseFloat(this.prepay_package_price).toFixed(2);
                }
            }
            if(selected_package && selected_package.is_snowboard_package){
                const payload = {name: 'dialog_snowboard_type'};
                if (this.model)
                    payload.data = {
                        model: {
                            snowboard_type: null,
                            reservee_modal_id: this.model._id,
                            customer_name: this.model.full_name
                        }
                    }
                this.ui__openModalByName(payload);
            }else{
                this.model.snowboard_type = "regular";
            }


        },

        heightChanged(height) {
            this.hideHeight = height > this.$store.state.resources.config.height;
        },

        shoeSizeChanged(shoeSize) {
            this.hideShoeSize = !shoeSize.includes("C") && parseFloat(shoeSize) > parseFloat(this.$store.state.resources.config.shoe_size);
        },

        weightChanged(weight) {
            this.hideWeight  = weight > parseInt(this.$store.state.resources.config.weight);
        },
        getHeightText(item) {
            let text = item.name;
            if(this.height_with_cm || this.$store.state.model.reservation.is_international_customer  || parseInt(this.$store.state.resources.config.is_international_canadian)){
                text = item.name +' ( '+ item.cm_value + ' cm )';
            }
            return text;
        },
        getShoeSize(item){
            let text = item.name;
            if((this.$store.state.model.reservation.is_international_customer || parseInt(this.$store.state.resources.config.is_international_canadian)) && item.uk_size!==""){
                text = item.name +' ( '+ item.uk_size + ' UK )';
            }
            return text;
        }
    },
    mounted() {

        this.tmpDob = this.dobFormatted;
        let age = moment().diff( this.tmpDob, 'years');
        this.hideAge = age > this.$store.state.resources.config.age;
        const self = this;
        this.changePackage();
        this.withValidation({
            getModel() {
                return self.modalState.model
            },
            rules : reservee_form__rules,
            fields: this.$store.state.model.reservation.is_prepay ? this.$store.state.model.reservation.is_international_customer?prepay_kgs_reservee_form__fields:(this.is_international_canadian)?(this.weight_unit_is_kg?prepay_kgs_reservee_form__fields:prepay_lbs_reservee_form__fields):this.weight_with_kg?prepay_kgs_reservee_form__fields:prepay_reservee_form__fields :this.$store.state.model.reservation.is_international_customer?reservee_kgs_form__fields: (this.is_international_canadian)?(this.weight_unit_is_kg?reservee_kgs_form__fields:reservee_lbs_form__fields):this.weight_with_kg?reservee_kgs_form__fields:reservee_form__fields
        })
    },
    created() {
        if(this.$store.state.model.reservation.group_link_id == 0 && !this.$store.state.model.reservation.is_prepay){
            this.$store.dispatch('load__package_addons');
        }
        this._originalPackageAddons = this.$store.state.resources.package_addons.filter((element) => {
            return ((this.$store.state.model.reservation._type=='kiosk' && element.remove_from_kiosk != 1) || (this.$store.state.model.reservation._type=='advance'));
        });;
    }
}
</script>

<style scoped>

</style>
